var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShootStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1L9 0C8.425 0.32 7.7 0.5 7 0.5C6.3 0.5 5.57 0.315 5 0C4.43 0.315 3.7 0.5 3 0.5C2.3 0.5 1.575 0.32 1 0L0 1C0 1 1 2 1 3C1 4 0 6 0 7C0 9 5 10 5 10C5 10 10 9 10 7C10 6 9 4 9 3C9 2 10 1 10 1ZM6.525 7.225L4.985 6.295L3.45 7.225L3.86 5.475L2.5 4.305L4.29 4.15L4.985 2.5L5.685 4.145L7.475 4.3L6.115 5.47L6.525 7.225Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShootStar);
export default __webpack_public_path__ + "static/media/ShootStar.c2f255439700305f8960466bb3875fcf.svg";
export { ForwardRef as ReactComponent };